import { HttpErrorService } from '@/services/HttpError.service'
import { venueErrorHandbook } from '@/models/Errors'
import type { VenuePageKit } from '@/models'
import { HttpService } from '@/services/Http.service'

export class VenuePageKitService {
  private httpErrorService: HttpErrorService<keyof typeof venueErrorHandbook>
  private endpoint = '/venue-page-kit/'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      venueErrorHandbook,
      'venue-page-kits',
    )
  }

  /**
   * @param id - если урл события содержит #hashtag, отдаем его в урле запросе
   */
  async getById(id: string | number) {
    const url = [this.endpoint, id].join('')

    return await this.httpService
      .get<VenuePageKit>(url, {
        fetchConfig: { timeout: 10000 },
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          needGlobal404: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
